import React, { memo, useContext } from "react"
import PropTypes from "prop-types"
import Slider from "react-slick"
import { analysisContext } from "context/analysis-context"

import ImageAnnotation from "./ImageAnnotation"
import { extractedFields } from "helpers/utils"

function PreviewDocs({ document = {} }) {
  const { gallery = [], extracted_data } = document
  const { slideIndex, setSlideIndex } = useContext(analysisContext)
  const fields = extractedFields(extracted_data, slideIndex)
  
  const settings = {
    dots: false,
    infinite: false,
    draggable: false,
    speed: 500,
    lazyLoad: true,
    beforeChange: (current, next) => setSlideIndex(next),
  }

  return (
    <Slider {...settings}>
      {gallery.map(image => {
        return <ImageAnnotation key={image} image={image} fields={fields} />
      })}
    </Slider>
  )
}
PreviewDocs.propTypes = {
  document: PropTypes.object,
}

export default memo(PreviewDocs)
